export default __webpack_public_path__ + "static/media/MyG.473bb392.png";